import { createClient } from '@deal/experiment-client';

var GraphQLExperimentClient = /** @class */ (function () {
    function GraphQLExperimentClient(options) {
        var _this = this;
        // On server-side, the Split IO client is expected to be fully initialized
        this.client = {
            clientPromise: createClient(options).then(function (client) {
                _this.client.client = client;
                _this.client.clientPromise = Promise.resolve(client);
                return client;
            })
        };
        this.treatment = this.treatment.bind(this);
    }
    GraphQLExperimentClient.prototype.treatment = function (_a) {
        var id = _a.id, attributes = _a.attributes, experiment = _a.experiment;
        var _b = this.client, client = _b.client, clientPromise = _b.clientPromise;
        var subject = { id: id, attributes: attributes };
        if (client) {
            var result = client.evaluate(experiment, subject);
            return {
                result: result.value,
                promise: Promise.resolve(result.value),
                active: Promise.resolve(result.version !== -1),
                changeNumber: Promise.resolve(result.version)
            };
        }
        else {
            var result = clientPromise.then(function (client) { return client.evaluate(experiment, subject); });
            return {
                promise: result.then(function (v) { return v.value; }),
                active: result.then(function (v) { return v.version !== -1; }),
                changeNumber: result.then(function (v) { return v.version; })
            };
        }
    };
    return GraphQLExperimentClient;
}());

export { GraphQLExperimentClient };
//# sourceMappingURL=graphql.js.map
